import { useEffect } from 'react';
import { getEmailTemplates } from '@/services/emailService';
import { useSequencesContext } from '../SequencesContext';

export type EmailTemplateType = {
	id: string;
	name: string;
	createdAt: string;
	body: string;
	subject: string;
	defaultTemplate: boolean;
	isStale: boolean;
	templateUsage: number;
	updatedAt: string;
};

export function useEmailTemplates() {
	const { emailTemplates, setEmailTemplates } = useSequencesContext();

	async function fetchTemplates() {
		const res = await getEmailTemplates();
		if (res.data) {
			setEmailTemplates(res.data.data);
		}
	}

	useEffect(() => {
		fetchTemplates();
	}, []);

	return {
		emailTemplates
	};
}
